import { render, staticRenderFns } from "./OrderMemberTable.vue?vue&type=template&id=3f0fd8fe&scoped=true&"
import script from "./OrderMemberTable.vue?vue&type=script&lang=js&"
export * from "./OrderMemberTable.vue?vue&type=script&lang=js&"
import style0 from "./OrderMemberTable.vue?vue&type=style&index=0&id=3f0fd8fe&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f0fd8fe",
  null
  
)

export default component.exports